import styled from 'styled-components';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const NestedFields = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

export const CorrelationIdGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
